export const SortDirectionEnum = Object.freeze({
  Asc: 'Asc',
  Desc: 'Desc'
});
